export default "__VITE_ASSET__BHGA26Zy__"